import { Button, Col, DatePicker, Flex, Input, Modal, Row, Select, Space, Table, TableColumnsType, TableProps, Tabs } from 'antd';
import Card from 'antd/es/card/Card';
import dayjs from "dayjs";
import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { changeCobDenialInvoiceStatus, deleteCobDenialInvoice, downloadCobDenialRawDataFile, downloadCobDenialSubmittedFile, generateCobDenialRawDataFile, getCobDenialInvoice, getCobDenialInvoiceActions, getCobDenialInvoiceAuditHistory, getCobDenialInvoiceStatusById, getCobDenialRawDataFiles, getCobDenialSubmittedFiles, saveCobDenialInvoice as save, submitCobDenialInvoice } from '../../../service/httpsCalls';
import "../billing.scss";
import { SorterResult } from 'antd/es/table/interface';
import { AuditTableColumns, DownloadDataColumns, DownloadFileColumns } from '../tableConfig';
import { LoaderSpinner } from '../../../components/common/Loader';
import TextArea from 'antd/es/input/TextArea';
import { DownloadOutlined, PlusOutlined } from '@ant-design/icons';
const { TabPane } = Tabs;
const { Option } = Select;
const { RangePicker } = DatePicker;

const { confirm } = Modal;


interface ClientData {
    id: number,
    name: string
}

interface AdditionInfo {
    caption: string,
    value: string
}

interface FilterData extends ClientData {
    clientId: number
}
interface FormFields {
    invoiceClient: any | null,
    clientName?: string,
    invoiceNumber: string | null,
    startDate: string | any,
    endDate: string | any,
    invoiceType: string | null,
    invoiceTypeName?: string,
    pdrCaseName?: string,
    invoiceDate: string | any,
    status: string | any,
    pdrCase: string | null,
    payerName: string | null;
    oaPayerName: string | null;
}

interface PaginationObject {
    totalPages: number,
    loading: boolean,
    pageSize: number,
    currentPage: number,
    sortInfo: SorterResult<any>,
    menuVisible: boolean
}

export type ChildRef = {
    getInvoiceData: (arg?: string) => void;
};
const COBDenialInvoiceDetails = forwardRef<ChildRef>(({ clientList, invoiceTypeLookup, parentCallback, pdrCaseList, closeModal, modalData, statusList }: any, ref) => {
    const [form, setForm] = useState<FormFields>({
        invoiceClient: '10',
        invoiceNumber: '',
        startDate: null,
        endDate: '',
        invoiceType: '1',
        invoiceDate: null,
        status: '',
        pdrCase: null,
        payerName: null,
        oaPayerName: null
    });

    let paginationObject: PaginationObject = {
        totalPages: 0,
        loading: false,
        pageSize: 5,
        currentPage: 1,
        sortInfo: {},
        menuVisible: false
    }
    const [globalAPICalled, setGlobalAPICalled] = useState(false);
    const [invoiceTypes, setInvoiceTypes] = useState<FilterData[]>(invoiceTypeLookup.filter((x: any) => x.clientId == '10'));
    const [modalSubmitted, setModalSubmitted] = useState(false);
    const [showSubmitForm, setShowSubmitForm] = useState(false);
    const [submitFormEdited, setSubmitFormEdited] = useState({
        mail: false,
        date: false
    })
    const [mailTracking, setMailTracking] = useState('');
    const [mailDate, setMailDate] = useState(null)
    const [editPermissions, setEditPermissions] = useState<any | null>(null)
    const [additionalInfo, setAdditionalInfo] = useState<AdditionInfo[]>([]);
    const [invoiceInfo, setInvoiceInfo] = useState<any | null>(null);
    const [downloadFiles, setDownloadFiles] = useState<any>([]);
    const [disableFilterSort, setDisableFilterSort] = useState(false);
    const [generatedData, setGeneratedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState({
        save: false,
        status: false,
        genarate: false,
        delete: false,
        submitFile: false,
        generateData: false,
        submit: false
    });
    const [auditHistory, setAuditHistory] = useState([]);
    const [auditTable, setAuditTable] = useState(paginationObject);
    const [downloadFileTable, setDownloadFileTable] = useState(paginationObject);

    const [statusForm, setStatusForm] = useState({
        note: '',
        status: '',
        statusName: '',
        visible: false,
        statusList: []
    });

    const auditColumns = AuditTableColumns.map(col =>
        col.dataIndex === 'oldValue' || col.dataIndex === 'newValue' || col.dataIndex === 'note'
            ? {
                ...col,
                onCell: (
                    () => ({ style: { overflowWrap: 'anywhere' } })
                )
            }
            : col
    );

    const [downloadDataTable, setDownloadDataTable] = useState(paginationObject);
    const downloadFileColumns = DownloadFileColumns;
    const downloadDataColumnsCopy = DownloadDataColumns.concat([
        {
            title: 'Download',
            dataIndex: 'fileName',
            render: (text, record) =>
                record.status == 'Generated' ?
                    <Button onClick={() => downloadSelectedDataFile(record)} loading={record.downloading} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }} type="primary">
                        <DownloadOutlined />
                    </Button> : ''

        }
    ])

    const [downloadDataColumns, setDownloadColumns] = useState<TableColumnsType<any>>(downloadDataColumnsCopy);

    useEffect(() => {
        if (modalData) {
            getInvoiceData()
            getAuditHistory();
            getDownloadFileData();
        }
    }, [modalData])

    function validateModal() {
        var isValid = true;
        var errorMessage = '';
        setModalSubmitted(true);
        const isPdrCaseType = form.invoiceTypeName === "PDR Cases";

        if (!(form.invoiceClient && form.invoiceType && form.pdrCase && form.invoiceNumber && form.startDate && form.endDate && form.invoiceDate && (isPdrCaseType ? form.pdrCase : true))) {
            isValid = false;
            errorMessage = "Please fill required details"
        }
        return { isValid, errorMessage };
    }

    function cancelModal(e?: any) {
        clearModalFields();
        setAuditHistory([]);
        setEditPermissions(null);
        setModalSubmitted(false);
        setInvoiceInfo(null);
        setAdditionalInfo([]);
        setLoader({
            save: false,
            status: false,
            genarate: false,
            delete: false,
            submitFile: false,
            generateData: false,
            submit: false,
        });
        setAuditTable(paginationObject);
        setStatusForm({
            note: '',
            status: '',
            statusName: '',
            visible: false,
            statusList: []
        })
        setDownloadFileTable(paginationObject);
        setDownloadDataTable(paginationObject);
        closeModal()
        if (e) {
            parentCallback({
                isCancel: true
            })
        }
    }

    function saveInvoice() {
        if (validateModal().isValid) {
            setLoader({
                ...loader,
                save: true,
            })
            save({
                "id": modalData.data.id,
                "clientId": parseInt(form.invoiceClient),
                "invoiceTypeId": parseInt(form.invoiceType ? form.invoiceType : '1'),
                "invoiceDate": dayjs(form.invoiceDate).format('YYYY-MM-DD'),
                "invoiceNumber": form.invoiceNumber,
                "fromPaymentDate": dayjs(form.startDate).format('YYYY-MM-DD'),
                "toPaymentDate": dayjs(form.endDate).format('YYYY-MM-DD'),
                "pdrCaseId": parseInt(form.pdrCase ? form.pdrCase : '1'),
            }, (res: any) => {
                setLoader({
                    ...loader,
                    save: false,
                })
                if (res?.hasError) {
                    const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                    parentCallback({
                        isInvalid: true,
                        errorMessage: errorMsg
                    })
                } else {
                    cancelModal();
                    parentCallback({
                        isInvalid: false,
                        clientId: form.invoiceClient,
                        invoiceTypeId: form.invoiceType,
                        message: 'Invoice saved successfully!'
                    })
                }
            })
        } else {
            parentCallback({
                isInvalid: true,
                errorMessage: validateModal().errorMessage
            })
        }
    }

    function clearModalFields() {
        setForm({
            ...form,
            invoiceDate: null,
            invoiceNumber: null,
            startDate: null,
            endDate: null,
            invoiceClient: null,
            invoiceType: null,
            status: '',
            pdrCase: null,
        });
        setInvoiceTypes([]);
    }

    function clientSelected(e: any) {
        if (e) {
            setForm({
                ...form,
                invoiceClient: e,
                invoiceType: '1',
            })
            setInvoiceTypes(invoiceTypeLookup.filter((x: any) => x.clientId == e));
        }
    }

    function getInvoiceData() {
        setLoading(true);
        getCobDenialInvoice(modalData.data.id, (res: any) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!';
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                })
            } else {
                setLoading(false);
                setInvoiceInfo(res.info);
                parentCallback({
                    canChangeTab: true,
                    canValidate: res.actions.canValidate
                });
                setForm({
                    invoiceClient: res.info.clientId.toString(),
                    clientName: res.info.clientName,
                    invoiceNumber: res.info.invoiceNumber,
                    startDate: dayjs(res.info.fromPaymentDate),
                    endDate: dayjs(res.info.toPaymentDate),
                    invoiceType: res.info.invoiceTypeId.toString(),
                    invoiceTypeName: res.info.invoiceType,
                    pdrCaseName: res.info.pdrCase,
                    invoiceDate: dayjs(res.info.invoiceDate),
                    status: res.info.status,
                    pdrCase: res.info.pdrCaseId?.toString(),
                    payerName: res.info.payerName,
                    oaPayerName: res.info.oaPayerName,
                })
                setInvoiceTypes(invoiceTypeLookup.filter((x: any) => x.clientId == res?.info?.clientId));
                setEditPermissions({
                    ...res.actions,
                    isDownloadTabVisible: res?.info?.isDownloadTabVisible ?? false,

                });
                setAdditionalInfo(res?.additionalInfo);
            }
        })
    }
    useImperativeHandle(ref, () => ({
        getInvoiceData,
    }));
    function deleteSelectedInvoice() {
        setLoader({
            ...loader,
            delete: true
        })
        deleteCobDenialInvoice(modalData.data.id, (res: any) => {
            setLoader({
                ...loader,
                delete: false
            })
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                })
            } else {
                cancelModal();
                parentCallback({
                    message: 'Invoice deleted successfully!'
                })
            }
        })
    }

    function confirmDelete() {
        confirm({
            title: 'Do you want to delete this invoice?',
            cancelText: "No",
            okText: "Yes",
            onOk() {
                deleteSelectedInvoice()
            },
            onCancel() { },
        });
    }

    function getAuditHistory() {
        setAuditTable({
            ...auditTable,
            loading: true
        })
        setAuditHistory([]);
        getCobDenialInvoiceAuditHistory({
            pageIndex: auditTable.currentPage,
            pageSize: auditTable?.pageSize,
            sortField: auditTable.sortInfo.order ? auditTable.sortInfo.field : null,
            sortDescending: auditTable.sortInfo.order == 'descend',
            id: modalData?.data.id
        }, (res: any) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!';
                parentCallback({
                    errorMessage: errorMsg
                })
                setAuditTable({
                    ...auditTable,
                    loading: false,
                    totalPages: 1
                });
            } else {
                setAuditHistory(res.items);
                setAuditTable({
                    ...auditTable,
                    loading: false,
                    totalPages: Math.ceil(res.totalRecords / (auditTable.pageSize / auditTable.pageSize))
                })
            }
        })
    }

    function generateDataFile() {
        setLoader({
            ...loader,
            generateData: true
        })
        generateCobDenialRawDataFile(modalData.data?.id, (res: any) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                });
            } else {
                parentCallback({
                    message: "File generation is in progress!!"
                });
            }
            if (downloadDataTable.currentPage == 1) {
                getDownloadFileData();
            }
            getInvoicePermissions();
            setLoader({
                ...loader,
                generateData: false
            })
        })
    }

    function getDownloadFileData() {
        setDownloadDataTable({
            ...downloadDataTable,
            loading: true
        })

        getCobDenialRawDataFiles({
            pageIndex: downloadDataTable.currentPage,
            pageSize: downloadDataTable?.pageSize,
            sortField: downloadDataTable.sortInfo.order ? downloadDataTable.sortInfo.field : null,
            sortDescending: downloadDataTable.sortInfo.order == 'descend',
            id: modalData?.data.id
        }, (res: any) => {
            setDownloadColumns(downloadDataColumnsCopy);
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!';
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                })
                setDownloadDataTable({
                    ...downloadDataTable,
                    loading: false,
                    totalPages: 1
                });
            } else {
                setGeneratedData(res.items);
                setDownloadDataTable({
                    ...downloadDataTable,
                    loading: false,
                    totalPages: Math.ceil(res.totalRecords / (downloadDataTable.pageSize / downloadDataTable.pageSize))
                })
            }
        })
    }

    function downloadFile(e: any, res: any) {
        // Create a Blob URL
        const blob = new Blob([res.data], { type: res.headers["content-type"] });
        const url = window.URL.createObjectURL(blob);

        // Create a link to trigger the download
        const link = document.createElement("a");
        link.href = url;
        const fileName = e?.fileName ?? "file.txt";// Change the filename and extension as needed
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link?.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    function downloadSelectedDataFile(e: any) {
        setGeneratedData((x: any) => x.map((rec: any) => rec.id == e.id ? { ...e, downloading: true } : rec));
        downloadCobDenialRawDataFile(e.id, (res: any) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                });
            } else {
                downloadFile(e, res);
                parentCallback({
                    isInvalid: false,
                    showMessage: true,
                    message: "File downloaded!!"
                });
            }
            setDisableFilterSort(generatedData?.filter((x: any) => x.downloading == true).length > 1);
            setTimeout(() => {
                setGeneratedData((x: any) => x.map((rec: any) => rec.id == e.id ? { ...e, downloading: false } : rec));
            }, 500)
        })
    }

    function getInvoicePermissions() {
        getCobDenialInvoiceActions(modalData?.data.id, (res: any) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                });
            } else {

                parentCallback({
                    canChangeTab: true,
                    canValidate: res.canValidate
                });
                setEditPermissions({
                    ...editPermissions,
                    ...res
                });
            }
        })
    }

    useEffect(() => {
        if (!globalAPICalled && modalData?.data.id) {
            setGlobalAPICalled(true);
        }
    });

    useEffect(() => {
        if (globalAPICalled) {
            getAuditHistory();
            getInvoiceData();
            getDownloadFileData();
            getSubmittedFileData();
        }
    }, [globalAPICalled]);

    useEffect(() => {
        if (disableFilterSort) {
            const updatedCols = downloadDataColumnsCopy.map((item) => { return { ...item, sorter: false } });
            setDownloadColumns(updatedCols);
        } else {
            setDownloadColumns(downloadDataColumnsCopy);
        }
    }, [disableFilterSort]);

    useEffect(() => {
        if (globalAPICalled && modalData?.data.id && auditTable.pageSize != 0)
            getAuditHistory();
    }, [auditTable.currentPage, auditTable.pageSize, auditTable.sortInfo]);

    const auditTableChanges: TableProps<any>['onChange'] = (pagination, filters, sorter, extra) => {
        setAuditTable({
            ...auditTable,
            currentPage: pagination.current ?? 1,
            pageSize: pagination.pageSize ?? 10,
            totalPages: pagination.total ?? 100,
            sortInfo: sorter as SorterResult<any>
        })
    }

    useEffect(() => {
        if (globalAPICalled && modalData?.data.id && downloadDataTable.pageSize != 0)
            getDownloadFileData();
    }, [downloadDataTable.currentPage, downloadDataTable.pageSize, downloadDataTable.sortInfo]);

    const downloadDataTableChanges: TableProps<any>['onChange'] = (pagination, filters, sorter, extra) => {
        if (disableFilterSort) {
            parentCallback({
                isInvalid: true,
                errorMessage: "Downloading is in progress!!!"
            });
            return;
        }
        setDownloadDataTable({
            ...downloadDataTable,
            currentPage: pagination.current ?? 1,
            pageSize: pagination.pageSize ?? 10,
            totalPages: pagination.total ?? 100,
            sortInfo: sorter as SorterResult<any>
        })
    }

    useEffect(() => {
        if (globalAPICalled && modalData?.data.id && downloadFileTable.pageSize != 0)
            getSubmittedFileData();
    }, [downloadFileTable.currentPage, downloadFileTable.pageSize, downloadFileTable.sortInfo]);

    const downloadFileTableChanges: TableProps<any>['onChange'] = (pagination, filters, sorter, extra) => {
        setDownloadFileTable({
            ...downloadFileTable,
            currentPage: pagination.current ?? 1,
            pageSize: pagination.pageSize ?? 10,
            totalPages: pagination.total ?? 100,
            sortInfo: sorter as SorterResult<any>
        })
    }

    function getStatus() {
        getCobDenialInvoiceStatusById(modalData?.data.id, (res: any) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.[0]?.description ?? 'Something went wrong!!!';
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                });

                // Defensive fallback if res has error
                if (form?.status && statusList?.length) {
                    const fallbackStatus = statusList.find(item => item.name === form.status);

                    setStatusForm({
                        visible: true,
                        status: fallbackStatus?.id ?? null,
                        statusName: form.status,
                        note: '',
                        statusList: statusList
                    });
                } else {
                    // Optional: fallback when not enough data to infer a status
                    setStatusForm({
                        visible: true,
                        status: '',
                        statusName: '',
                        note: '',
                        statusList: statusList ?? []
                    });
                }

            } else {
                const filteredStatusList = statusList.filter(
                    x =>
                        x.clientId == form.invoiceClient &&
                        x.invoiceTypeId == form.invoiceType &&
                        res.statusIds?.split(',').map(y => parseInt(y)).includes(x.id)
                );

                const matchedStatus = filteredStatusList.find(item => item.id === res?.invoiceStatusId);

                setStatusForm({
                    visible: true,
                    status: res?.invoiceStatusId,
                    statusName: matchedStatus?.name ?? '',
                    note: res?.note ?? '',
                    statusList: filteredStatusList
                });
            }
        });
    }

    function saveStatus(isSubmit: boolean = false) {
        setLoader({
            ...loader,
            status: true
        });

        changeCobDenialInvoiceStatus({
            cobDenialInvoiceSId: modalData?.data.id,
            clientId: invoiceInfo.clientId,
            statusId: isSubmit ? invoiceInfo.submitStatusId : statusForm.status,
            note: isSubmit ? '' : statusForm.note
        }, (res: any) => {
            setLoader({
                ...loader,
                status: false
            })
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                });
            } else {
                getAuditHistory();
                getInvoiceData();
                if (!isSubmit) {
                    setStatusForm({ ...statusForm, visible: false });
                }
                const msg = isSubmit ? "Invoice submission Process is in Queue!" : "Status changed successfully!"
                parentCallback({
                    isInvalid: false,
                    showMessage: true,
                    message: msg
                });
            }
        })
    }

    function getSubmittedFileData() {
        setDownloadFileTable({
            ...downloadFileTable,
            loading: true
        })
        getCobDenialSubmittedFiles({
            pageIndex: downloadFileTable.currentPage,
            pageSize: downloadFileTable?.pageSize,
            sortField: downloadFileTable.sortInfo.order ? downloadFileTable.sortInfo.field : null,
            sortDescending: downloadFileTable.sortInfo.order == 'descend',
            id: modalData?.data.id
        }, (res: any) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!';
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                })
                setDownloadFileTable({
                    ...downloadFileTable,
                    loading: false,
                    totalPages: 1
                });
            } else {
                setDownloadFiles(res.items);
                setDownloadFileTable({
                    ...downloadFileTable,
                    loading: false,
                    totalPages: Math.ceil(res.totalRecords / (downloadFileTable.pageSize / downloadFileTable.pageSize))
                })
            }
        })
    }

    function downloadSelectedSubmittedFile() {
        setLoader({
            ...loader,
            submitFile: true
        })

        downloadCobDenialSubmittedFile(modalData?.data.id, (res: any) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                });
            } else {
                downloadFile(downloadFiles.length ? downloadFiles[0] : null, res);
                parentCallback({
                    isInvalid: false,
                    showMessage: true,
                    message: "File downloaded!!"
                });
            }
            if (downloadFileTable.currentPage == 1) {
                getSubmittedFileData();
            } else {
                setDownloadFileTable({
                    ...downloadFileTable, currentPage: 1
                })
            }
            setLoader({
                ...loader,
                submitFile: false
            })
        })
    }

    const openSubmitForm = () => {
        setShowSubmitForm(true);
    }

    const closeSubmitForm = () => {
        setShowSubmitForm(false);
        setMailDate(null)
        setMailTracking('');
    }

    function submitInvoice() {
        if (mailTracking !== '' && mailDate !== null) {
            setLoader({
                ...loader,
                submit: true,
            })
            
            submitCobDenialInvoice({
                "cobDenialInvoiceSId": modalData.data.id,
                "certifiedMailTrackingNumber": mailTracking,
                "mailDate": dayjs(mailDate).format('YYYY-MM-DD'),
            }, (res: any) => {
                setSubmitFormEdited({
                    mail: false,
                    date: false
                });
                setLoader({
                    ...loader,
                    submit: false,
                })
                if (res?.hasError) {
                    const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                    parentCallback({
                        isInvalid: true,
                        errorMessage: errorMsg
                    })
                } else {
                    cancelModal();
                    parentCallback({
                        isInvalid: false,
                        message: 'Invoice submitted successfully!'
                    })
                }
            })
        } else {
            parentCallback({
                isInvalid: true,
                errorMessage: 'Please fill required details'
            })
        }
    }

    return (

        <div style={{ paddingTop: '15px', backgroundColor: 'none', }}>
            {editPermissions && invoiceInfo ? <>
                <Card styles={{ body: { padding: '15px' } }} loading={loading}>
                    <p
                        style={{
                            fontSize: 14,
                            color: 'rgba(0, 0, 0, 0.85)',
                            marginTop: '0px',
                            fontWeight: 500,
                        }}
                    >
                        Invoice Information
                    </p>
                    {editPermissions.canEdit ?
                        <div>
                            <Row style={{ paddingBottom: '1rem', background: '#fff' }}>
                                <Col span={6} style={{ paddingRight: '0.5rem' }}>
                                    <label>Client</label>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="Select a Client"
                                        onChange={(e) => clientSelected(e)}
                                        status={modalSubmitted && !form.invoiceClient ? 'error' : ''}
                                        value={form.invoiceClient}
                                        disabled={true}
                                    >
                                        {clientList && clientList.map((item: any) => (
                                            <Option key={item.id}>{item.name}</Option>
                                        ))}
                                    </Select>
                                </Col>
                            </Row>
                            <Row style={{ paddingBottom: '1rem', background: '#fff' }}>
                                <Col span={6} style={{ paddingRight: '0.5rem' }}>
                                    <label>Invoice Type</label>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="Invoice Type"
                                        onChange={(e) => setForm({
                                            ...form,
                                            invoiceType: e
                                        })}
                                        status={modalSubmitted && !form.invoiceType ? 'error' : ''}
                                        value={form.invoiceType}
                                        disabled={true}
                                    >
                                        {invoiceTypes && invoiceTypes.map(item => (
                                            <Option key={item.id}>{item.name}</Option>
                                        ))}
                                    </Select>
                                </Col>
                                {form.invoiceTypeName === "PDR Cases" && (
                                    <Col span={6} style={{ paddingRight: '0.5rem' }}>
                                        <label>PDR Case</label>
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="PDR Case"
                                            onChange={(e) => setForm({ ...form, pdrCase: e })}
                                            status={modalSubmitted && !form.pdrCase ? 'error' : ''}
                                            value={form.pdrCase}
                                        >
                                            {pdrCaseList.map((item: any) => (
                                                <Option key={item.id}>{item.name}</Option>
                                            ))}
                                        </Select>
                                    </Col>
                                )}
                                <Col span={6} style={{ paddingRight: '0.5rem' }}>
                                    <label>Invoice #</label>
                                    <Input value={form.invoiceNumber ?? ''} status={modalSubmitted && !form.invoiceNumber ? 'error' : ''} disabled={!form.invoiceClient || !form.invoiceType} placeholder="Invoice #" style={{ width: '100%' }} allowClear
                                        maxLength={100}
                                        onChange={(e) => {
                                            setForm({
                                                ...form,
                                                invoiceNumber: e?.target?.value
                                            })
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ paddingBottom: '1rem', background: '#fff' }}>
                                <Col span={6} style={{ paddingRight: '0.5rem' }}>
                                    <label>Invoice Date</label>
                                    <DatePicker placeholder='Invoice Date' status={modalSubmitted && !form.invoiceDate ? 'error' : ''} value={form.invoiceDate} format="MM/DD/YYYY" disabled={!form.invoiceClient || !form.invoiceType} style={{ width: '100%' }}
                                        onChange={(date: any) => {
                                            setForm({
                                                ...form,
                                                invoiceDate: date ? date : ''
                                            })
                                        }}
                                    />
                                </Col>
                                <Col span={12} style={{ paddingRight: '0.5rem' }}>
                                    <label>Payment Date Range</label>
                                    <RangePicker style={{ width: '100%' }}
                                        format="MM/DD/YYYY"
                                        value={[form.startDate, form.endDate]}
                                        status={modalSubmitted && !(form.startDate && form.endDate) ? 'error' : ''}
                                        disabled={!form.invoiceClient || !form.invoiceType}
                                        onChange={(dates: any) => {
                                            if (dates) {
                                                setForm({
                                                    ...form,
                                                    startDate: dates[0],
                                                    endDate: dates[1]
                                                })
                                            } else {
                                                setForm({
                                                    ...form,
                                                    startDate: '',
                                                    endDate: ''
                                                })
                                            }
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Flex justify="end">
                                <Space>
                                    <Button key="3" onClick={e => cancelModal(e)} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }} type="primary">
                                        Cancel
                                    </Button>
                                    <Button key="1" onClick={e => saveInvoice()} style={{ backgroundColor: "#ff4d4f", color: "#fff" }}>Save</Button>
                                    {
                                        editPermissions.canDelete &&
                                        <Button key="4" onClick={e => confirmDelete()} style={{ backgroundColor: "blue", color: "#fff" }}>Delete</Button>
                                    }
                                </Space>
                            </Flex>
                        </div> :
                        <div>
                            <Row style={{ paddingBottom: '1rem', background: '#fff' }}>
                                <Col span={4} style={{ paddingRight: '0.5rem' }}>
                                    <label>Client</label>
                                    <br />
                                    {form.clientName}
                                </Col>
                                <Col span={4} style={{ paddingRight: '0.5rem' }}>
                                    <label>Invoice Type</label>
                                    <br />
                                    {form.invoiceTypeName}
                                </Col>
                                <Col span={4} style={{ paddingRight: '0.5rem', wordBreak: "break-all" }}>
                                    <label>Invoice #</label><br />
                                    {form.invoiceNumber}
                                </Col>
                                {form.invoiceTypeName === "PDR Cases" && (
                                    <Col span={4} style={{ paddingRight: '0.5rem' }}>
                                        <label>PDR Case</label>
                                        <br />
                                        {form.pdrCaseName}
                                    </Col>
                                )}

                                {form.invoiceTypeName === "837p Office Ally" && (
                                    <>
                                        <Col span={4} style={{ paddingRight: '0.5rem' }}>
                                            <label>Payer Name</label>
                                            <br />
                                            {form.payerName}
                                        </Col>
                                        <Col span={4} style={{ paddingRight: '0.5rem' }}>
                                            <label>OA Payer Name</label>
                                            <br />
                                            {form.oaPayerName}
                                        </Col>
                                    </>
                                )}

                            </Row>
                            <Row style={{ paddingBottom: '1rem', background: '#fff' }}>
                                <Col span={4} style={{ paddingRight: '0.5rem' }}>
                                    <label>Invoice Date</label>
                                    <br />
                                    {form.invoiceDate ? dayjs(form.invoiceDate).format('MM/DD/YYYY') : ''}
                                </Col>
                                <Col span={4} style={{ paddingRight: '0.5rem' }}>
                                    <label>From Payment Date</label>
                                    <br />
                                    {form.startDate ? dayjs(form.startDate).format('MM/DD/YYYY') : ''}
                                </Col>
                                <Col span={4} style={{ paddingRight: '0.5rem' }}>
                                    <label>To Payment Date</label>
                                    <br />
                                    {form.endDate ? dayjs(form.endDate).format('MM/DD/YYYY') : ''}
                                </Col>
                                <Col span={4} style={{ paddingRight: '0.5rem' }}>
                                    <label>Status</label>
                                    <br />
                                    {form.status}
                                </Col>
                            </Row>
                            <Flex justify="end">
                                <Space>
                                    {
                                        editPermissions?.canChangeStatus &&
                                        <Button key="changeStatusBtn" disabled={statusForm.visible} onClick={e => getStatus()} style={{ backgroundColor: "blue", color: "#fff" }}>Change Status</Button>
                                    }

                                    {
                                        editPermissions?.canSubmit &&
                                        <Button key="submitBtn" onClick={openSubmitForm} loading={loader.status} style={{ backgroundColor: "#52c41a", color: "#fff" }}>Submit</Button>
                                    }
                                </Space>
                            </Flex>
                        </div>
                    }
                </Card>
                {
                    <div style={{ padding: "1rem", background: '#eff1f5' }}></div>
                }
                {
                    editPermissions?.canChangeStatus && statusForm.visible &&
                    <div style={{ background: "#eff1f5" }}>
                        <Card styles={{ body: { padding: '15px' } }}>
                            <p
                                style={{
                                    fontSize: 14,
                                    color: 'rgba(0, 0, 0, 0.85)',
                                    marginTop: '0px',
                                    fontWeight: 500,
                                }}
                            >
                                Change Status
                            </p>
                            <Row style={{ paddingBottom: '0.5rem' }}>
                                <Col span={8}>
                                    <label>Status</label>
                                    <Select
                                        style={{ width: '95%' }}
                                        placeholder="Select a Status"
                                        onChange={(e) => {
                                            const selectedStatus = statusForm.statusList.find(item => item.id === e);
                                            setStatusForm({
                                                ...statusForm,
                                                status: e,
                                                statusName: selectedStatus?.name ?? '',
                                                note: ''
                                            });
                                        }}
                                        value={statusForm.status}
                                        status={!statusForm.status ? 'error' : ''}
                                    >
                                        {statusForm.statusList && statusForm.statusList.map(item => (
                                            <Option key={item.id} value={item.id}>{item.name}</Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col span={10}>
                                    <label>Note</label>
                                    <TextArea
                                        placeholder="Enter Note"
                                        autoSize={{ minRows: 2, maxRows: 6 }}
                                        value={statusForm.note}
                                        maxLength={300}
                                        onChange={(e: any) => setStatusForm({ ...statusForm, note: e.target.value })}
                                    />
                                </Col>
                            </Row>
                            <Flex justify="end">
                                <Space>
                                    <Button key="saveNote" loading={loader.status} disabled={!statusForm.status} onClick={e => saveStatus()} style={{ backgroundColor: "blue", color: "#fff" }}>Save</Button>
                                    <Button key="cancelNote" onClick={e => setStatusForm({ ...statusForm, visible: false })} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }}>Cancel</Button>
                                </Space>
                            </Flex>
                        </Card>
                        <div style={{ padding: "1rem" }}></div>
                    </div>
                }
                {
                    editPermissions?.canSubmit && showSubmitForm &&
                    <div style={{ background: "#eff1f5" }}>
                        <Card styles={{ body: { padding: '15px' } }}>
                            <p
                                style={{
                                    fontSize: 14,
                                    color: 'rgba(0, 0, 0, 0.85)',
                                    marginTop: '0px',
                                    fontWeight: 500,
                                }}
                            >
                                Submit Invoice
                            </p>
                            <Row  style={{ paddingBottom: '0.5rem' }}>
                                <Col span={10}>
                                    <label>Certified Mail Tracking #</label>
                                    <Input maxLength={100} value={mailTracking} status={editPermissions.canSubmit && submitFormEdited.mail && mailTracking === '' ? 'error' : ''} placeholder="Certified Mail Tracking #" style={{ width: '95%' }} allowClear
                                        onChange={(e) => {
                                            setSubmitFormEdited({
                                                ...submitFormEdited, mail: true
                                            });
                                            setMailTracking(e.target.value)
                                        }}
                                    />
                                </Col>
                                <Col span={8}>
                                    <label>Mail Date</label>
                                    <DatePicker placeholder='Mail Date' status={editPermissions.canSubmit && submitFormEdited.date && !mailDate ? 'error' : ''} value={mailDate} format="MM/DD/YYYY" style={{ width: '100%' }}
                                        onChange={(date: any) => {
                                            setSubmitFormEdited({
                                                ...submitFormEdited, date: true
                                            })
                                            setMailDate(date)
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Flex justify="end">
                                <Space>
                                    <Button key="saveNote" loading={loader.status} onClick={e => submitInvoice()} style={{ backgroundColor: "blue", color: "#fff" }}>Save</Button>
                                    <Button key="cancelNote" onClick={closeSubmitForm} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }}>Cancel</Button>
                                </Space>
                            </Flex>
                        </Card>
                        <div style={{ padding: "1rem" }}></div>
                    </div>
                }
                {
                    (!editPermissions?.canEdit) && additionalInfo?.length > 0 &&
                    <div style={{ background: "#eff1f5" }}>
                        <Card styles={{ body: { padding: '15px' } }}>
                            <p
                                style={{
                                    fontSize: 14,
                                    color: 'rgba(0, 0, 0, 0.85)',
                                    marginTop: '0px',
                                    fontWeight: 500,
                                }}
                            >
                                Additional Information
                            </p>
                            <Row style={{ background: '#fff' }}>
                                {
                                    additionalInfo && additionalInfo.map((item, index) => (
                                        <Col key={index} span={4} style={{ paddingRight: '0.5rem', paddingBottom: '0.5rem', wordBreak: "break-word" }}>
                                            <label key={'label' + index}>{item.caption}</label>
                                            <br />
                                            {item.value}
                                        </Col>
                                    ))}
                            </Row>
                        </Card>
                        <div style={{ padding: "1rem" }}></div>
                    </div>
                }
                <Flex style={{ padding: "1rem", background: '#fff' }}>
                    <Tabs type="card" style={{ width: '100%' }}>
                        <TabPane tab="Audit History" key="auditHistoryTab">
                            <Table style={{ overflowY: "auto", height: "auto" }}
                                dataSource={auditHistory}
                                pagination={{
                                    defaultCurrent: 1,
                                    current: auditTable.currentPage,
                                    pageSize: auditTable.pageSize,
                                    total: auditTable.totalPages,
                                    showTotal: (total, range) => `${range[0] || 0}-${range[1] || 1} of ${total} items`,
                                    showSizeChanger: true,
                                }}
                                columns={auditColumns}
                                onChange={auditTableChanges}
                                rowKey="date"
                                loading={{ indicator: <LoaderSpinner size={24} topMargin="10px" />, spinning: auditTable.loading }}
                                onHeaderRow={() => {
                                    return {
                                        onContextMenu: (event) => {
                                            event.preventDefault();
                                            if (!auditTable.menuVisible) {
                                                document.addEventListener(`click`, function onClickOutside() {
                                                    setAuditTable({
                                                        ...auditTable,
                                                        menuVisible: false
                                                    });
                                                    document.removeEventListener(`click`, onClickOutside);
                                                });
                                            }
                                            setAuditTable({
                                                ...auditTable,
                                                menuVisible: true
                                            });
                                        }
                                    };
                                }}
                            />
                        </TabPane>
                        <TabPane tab="Download Imported Data" key="downloadTab">
                            {
                                editPermissions.canDownloadGeneratedData &&
                                <div style={{ paddingBottom: '5px' }}>
                                    <Button key="generateFile" loading={loader.generateData} onClick={e => generateDataFile()} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }}>
                                        <PlusOutlined /> Generate File
                                    </Button>
                                </div>
                            }
                            <Table style={{ overflowY: "auto", height: "auto" }}
                                dataSource={generatedData}
                                pagination={{
                                    defaultCurrent: 1,
                                    current: downloadDataTable.currentPage,
                                    pageSize: downloadDataTable.pageSize,
                                    total: downloadDataTable.totalPages,
                                    showTotal: (total, range) => `${range[0] || 0}-${range[1] || 1} of ${total} items`,
                                    showSizeChanger: true,
                                    disabled: disableFilterSort
                                }}
                                columns={downloadDataColumns}
                                onChange={downloadDataTableChanges}
                                rowKey="id"
                                loading={{ indicator: <LoaderSpinner size={24} topMargin="10px" />, spinning: downloadDataTable.loading }}
                                onHeaderRow={(columns, index) => {
                                    return {
                                        onContextMenu: (event) => {
                                            event.preventDefault();
                                            if (!downloadDataTable.menuVisible) {
                                                document.addEventListener(`click`, function onClickOutside() {
                                                    setDownloadDataTable({
                                                        ...downloadDataTable,
                                                        menuVisible: false
                                                    });
                                                    document.removeEventListener(`click`, onClickOutside);
                                                });
                                            }
                                            setDownloadDataTable({
                                                ...downloadDataTable,
                                                menuVisible: true
                                            });
                                        }
                                    };
                                }}
                            />
                        </TabPane>
                        {form.invoiceTypeName === "837p Office Ally" &&
                            <TabPane tab="Download Submitted File" key="downloadFile">
                                {
                                    editPermissions?.canDownloadSubmittedFile &&
                                    <div style={{ paddingBottom: '5px' }}>
                                        <Button key="downloadSubmittedBtn" loading={loader.submitFile} onClick={e => downloadSelectedSubmittedFile()} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }}>
                                            <DownloadOutlined /> Download Submitted File
                                        </Button>
                                    </div>
                                }
                                <Table style={{ overflowY: "auto", height: "auto" }}
                                    dataSource={downloadFiles}
                                    pagination={{
                                        defaultCurrent: 1,
                                        current: downloadFileTable.currentPage,
                                        pageSize: downloadFileTable.pageSize,
                                        total: downloadFileTable.totalPages,
                                        showTotal: (total, range) => `${range[0] || 0}-${range[1] || 1} of ${total} items`,
                                        showSizeChanger: true,
                                    }}
                                    columns={downloadFileColumns}
                                    onChange={downloadFileTableChanges}
                                    rowKey="id"
                                    loading={{ indicator: <LoaderSpinner size={24} topMargin="10px" />, spinning: downloadFileTable.loading }}
                                    onHeaderRow={(columns, index) => {
                                        return {
                                            onContextMenu: (event) => {
                                                event.preventDefault();
                                                if (!downloadFileTable.menuVisible) {
                                                    document.addEventListener(`click`, function onClickOutside() {
                                                        setDownloadFileTable({
                                                            ...downloadFileTable,
                                                            menuVisible: false
                                                        });
                                                        document.removeEventListener(`click`, onClickOutside);
                                                    });
                                                }
                                                setDownloadFileTable({
                                                    ...downloadFileTable,
                                                    menuVisible: true
                                                });
                                            }
                                        };
                                    }}
                                />
                            </TabPane>
                        }
                    </Tabs>
                </Flex>
            </> : 
            <>   <Card styles={{ body: { padding: '15px' } }} loading={loading}></Card></>
            }

        </div>
    )
})

export default COBDenialInvoiceDetails;
